import type { Role, UserImportReason } from '../api/types'
import { DASH } from '../ui/format'

// 화면이 쓰는 낱말 중 여러 화면이 함께 쓰는 것. 한 낱말은 한 뜻만. 사전에 없는 값은 대시다.

/**
 * 정하지 않은 자리. 사양의 자원과 직위의 한도가 같은 낱말을 쓴다 — 비운 칸이 자유이고,
 * 없는 값(`—`)과 다르다. 쓸 때 그 축을 본문에 싣지 않는 것이 이 낱말이다.
 */
export const FREE = '자유'

/** OAuth 제공자의 표시 이름(F-34). */
export const PROVIDER_LABEL: Record<'google' | 'github', string> = { google: 'Google', github: 'GitHub' }

export const roleLabel = { superadmin: '최고 관리자', admin: '관리자', user: '사용자' } as const

/** 사용자 목록의 구획 순서와 이름(F-42). 윗사람부터 본다. */
export const ROLE_ORDER = ['superadmin', 'admin', 'user'] as const
export const ROLE_SECTION: Record<Role, string> = { superadmin: '최고 관리자', admin: '관리자', user: '일반 유저' }

/** 그 사람에게 팀이 무엇인가 — 관리자에게는 관리하는 팀, 사용자에게는 속한 팀이다. */
export const teamColumn = (role: Role) => (role === 'user' ? '소속 팀' : '관리 팀')

// 적힌 순서가 곧 멤버 줄의 순서다 — 관리자가 먼저 온다. 사전에 없는 자리는 맨 뒤다.
const TEAM_ROLE: Record<string, string> = { owner: '관리자', member: '멤버', viewer: '보기만' }
export function teamRoleWord(role: string): string {
  return TEAM_ROLE[role] ?? DASH
}
export function teamRoleRank(role: string): number {
  const i = Object.keys(TEAM_ROLE).indexOf(role)
  return i < 0 ? Object.keys(TEAM_ROLE).length : i
}

/** 일괄 등록에서 건너뛴 줄의 이유(F-77). 줄마다 한 문장이다. */
export const IMPORT_REASON: Record<UserImportReason, string> = {
  empty: '빈 줄입니다.',
  invalid_name: '이름이 비었거나 너무 깁니다.',
  invalid_username: '아이디 형식이 아닙니다.',
  reserved_username: 'VM 안에서 이미 쓰는 아이디입니다.',
  invalid_email: '이메일 형식이 아닙니다.',
  duplicate_username: '위 줄과 아이디가 같습니다.',
  duplicate_email: '위 줄과 이메일이 같습니다.',
  username_taken: '이미 쓰는 아이디입니다.',
  email_taken: '이미 쓰는 이메일입니다.',
}
